module.exports = __webpack_public_path__ + "static/media/electrodomesticos.90f3649b.jpg";